export default __webpack_public_path__ + "static/media/praesto.5c293bf0.png";